/* Card Emblems v99-fix2 — PDP "Complete the set" rail behavior reinforcement.
   The rail uses scroll-snap-type:x mandatory, which silently breaks
   scrollBy({behavior:'smooth'}) on Chrome. The inline section JS calls
   scrollBy with smooth on prev/next click, so the row never actually scrolls
   and no scroll event fires, leaving prev.disabled stuck. This patch:
     1. Re-attaches a redundant scroll listener that updates disabled state.
     2. Overrides prev/next click handlers (capture phase, stops propagation)
        to use direct scrollLeft assignment — bypasses the snap+smooth bug
        while still letting scroll-snap align to the nearest card.
     3. Re-checks the disabled state after load to catch lazy-load shifts. */
(function () {
  var patched = new WeakSet();

  function patch(row) {
    if (patched.has(row)) return;
    var sid = row.id.replace(/^cebem-recs-row-/, '');
    var prev = document.getElementById('cebem-recs-prev-' + sid);
    var next = document.getElementById('cebem-recs-next-' + sid);
    if (!prev || !next) return;
    patched.add(row);

    function upd() {
      var ms = row.scrollWidth - row.clientWidth;
      var atStart = row.scrollLeft <= 2;
      var atEnd = row.scrollLeft >= ms - 2;
      if (prev.disabled !== atStart) prev.disabled = atStart;
      if (next.disabled !== atEnd) next.disabled = atEnd;
    }

    row.addEventListener('scroll', upd, { passive: true });
    window.addEventListener('resize', upd);

    function step(dir) {
      var card = row.querySelector(':scope > *');
      if (!card) return;
      var w = card.getBoundingClientRect().width + 14;
      var target = Math.max(0, row.scrollLeft + dir * w);
      row.scrollLeft = target;
      requestAnimationFrame(upd);
      setTimeout(upd, 60);
      setTimeout(upd, 200);
    }

    prev.addEventListener('click', function (e) {
      e.stopImmediatePropagation();
      step(-1);
    }, true);
    next.addEventListener('click', function (e) {
      e.stopImmediatePropagation();
      step(1);
    }, true);

    upd();
    setTimeout(upd, 200);
    setTimeout(upd, 800);
  }

  function scan() {
    document.querySelectorAll('[id^="cebem-recs-row-"]').forEach(patch);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
  setTimeout(scan, 600);
  setTimeout(scan, 1800);
})();
